module.exports = __webpack_public_path__ + "static/media/logo_hongleongbank.e7ed13f5.svg";